import qs from 'qs';
import _flow from 'lodash/flow';
import _isEmpty from 'lodash/isEmpty';
import _isObject from 'lodash/isObject';
import { isAbsoluteURL, combineURLs, mergeData, pickNonEmpty } from './helpers';

const encode = (val) =>
  encodeURIComponent(val)
    .replace(/%3A/gi, ':')
    .replace(/%24/g, '$')
    .replace(/%2C/gi, ',')
    .replace(/%20/g, '+')
    .replace(/%5B/gi, '[')
    .replace(/%5D/gi, ']');

export const buildFullPath = (requestedURL, baseURL) => {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

export function buildURL(url, params) {
  // 将请求的 url restful 化
  let newURL = url;

  if (!_isObject(params)) {
    return newURL;
  }

  if (/:/.test(url)) {
    // 匹配 /users/:id/:name 中的 :id、:name
    const pattern = /:\w+/g;

    // 替换 url 并且将请求参数中的相关属性删除
    newURL = url.replace(pattern, (keyword) => {
      const key = keyword.substring(1);
      const value = params[key];
      delete params[key];
      return encode(value);
    });
  }

  if (!_isEmpty(params)) {
    newURL = `${newURL}?${qs.stringify(params)}`;
  }

  return newURL;
}

export const pickData = _flow([mergeData, pickNonEmpty]);
